import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IStaffProfileDetailResponse, IStaffProfile } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useStaffProfileDetailAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [staff, setStaff] = useState<IStaffProfile | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const execute = useCallback(
    async (staffId: string) => {
      if (!staffId) return null;
      setIsLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.get<IStaffProfileDetailResponse>(
          `${CONFIGURATION_APIS.STAFF_PROFILE_DETAIL.baseURL}${staffId}/`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        setStaff(response.data?.data ?? null);
        return response.data?.data ?? null;
      } catch (error) {
        setStaff(null);
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [configuration],
  );

  return { execute, staff, isLoading };
};
